import { PageState, Spinner, Card } from "@myob/myob-widgets";
import { cardMarginStyle } from "./Card.css";
import PropTypes from "prop-types";

const CardWithLoadingStatus = ({ title = "Loading" }) => {
  return (
    <div className={cardMarginStyle}>
      <Card>
        <PageState title={title} image={<Spinner size="medium" />}></PageState>
      </Card>
    </div>
  );
};

CardWithLoadingStatus.propTypes = {
  title: PropTypes.string,
};

export default CardWithLoadingStatus;
